<template>
  <div id="trip-step">
    <div id="step-summary">
      <h3 v-html="step.html_instructions"></h3>
      <div class="step-info">
        <div>
          <p>{{ timeAtStep }}</p>
          <p>{{ step.road.Location.Address.Label }}</p>
        </div>

        <Risk :risk="risk" />
      </div>
    </div>

    <StepMetrics v-if="metrics" />
    <StepNotes v-else />

    <div id="step-actions">
      <button @click="exitRoute"><font-awesome-icon icon="times-circle" /></button>
      <button @click="metrics = !metrics"><font-awesome-icon :icon="metrics ? 'sticky-note' : 'traffic-light'" /></button>
      <button @click="prevStep" v-if="stepIndex"><font-awesome-icon icon="arrow-left" /></button>
      <button @click="nextStep" v-if="(stepIndex + 1) < totalStepCount"><font-awesome-icon icon="arrow-right" /></button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import Risk from './Risk';
import StepMetrics from './StepMetrics';
import StepNotes from './StepNotes';

export default {
  components: { Risk, StepMetrics, StepNotes },
  async mounted() {
    this.risk = await this.$store.dispatch('getModelForStep', this.step);
  },
  data() {
    return {
      metrics: true,
      risk: null,
    }
  },
  methods: {
    exitRoute() {
      this.$store.commit('setItem', { key: 'stepIndex', value: 0 });
      this.$store.commit('setItem', { key: 'route', value: null });
    },
    prevStep() {
      this.$store.commit('setItem', { key: 'stepIndex', value: this.stepIndex - 1 });
    },
    nextStep() {
      this.$store.commit('setItem', { key: 'stepIndex', value: this.stepIndex + 1 });
    }
  },
  computed: {
    step() {
      return this.$store.state.route.legs[0].steps[this.$store.state.stepIndex];
    },
    timeAtStep() {
      return moment(this.step.timeAtStep).format('dddd, MMMM Do YYYY, h:mm: A')
    },
    stepIndex() {
      return this.$store.state.stepIndex;
    },
    totalStepCount() {
      return this.$store.state.route.legs[0].steps.length;
    }
  },
  watch: {
    async step() {
      this.risk = await this.$store.dispatch('getModelForStep', this.step);
    }
  }
}
</script>

<style>
#trip-step {
  position: absolute;
  top: 15px;
  left: 15px;
}

#step-summary {
  background: #fff;
  padding: 1rem;
  border-radius: 6px;
  width: 600px;
  margin: 5px 0;
}

.step-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgba(0, 0, 0, .8);
  margin-top: 10px;
}

#step-actions {
  margin-top: 10px;
}

#step-actions button {
  animation: all 350ms;
  margin-right: 10px;
  font-size: 20px;
  background: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  color: #333;
  cursor: pointer;
}

#step-actions button:hover {
  background: #eee;
}

@media(max-width: 600px) {
  #step-summary {
    width: 100%;
    margin: 5px 0;
  }

  #step-metrics {
    margin: 5px 0;
  }
}
</style>
